import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { CRMService } from '../../services/crm.service';
import { UtilService } from '../../services/util.service';
import {
    OpportunityQuestionMap,
    SearchOpportunityQuestion,
    SearchOpportunityQuestionMap
} from '../../models/models';

@Component({
    selector: 'customer-opportunity-question',
    templateUrl: './customer-opportunity-question.component.html',
    standalone: false
})
export class CustomerOpportunityQuestion implements OnChanges {
    @Input() title: string = "Actions";
    @Input() expanded: boolean = true;
    @Input() opportunityID: number = 0;

    @Output() questionSaved: EventEmitter<boolean> = new EventEmitter<boolean>();

    public customerActionID: number = 0;
    public opportunityQuestionMap: OpportunityQuestionMap = {} as OpportunityQuestionMap;
    public questionMapList: SearchOpportunityQuestionMap[] = [];
    public questionList: SearchOpportunityQuestion[] = [];

    constructor(private crmService: CRMService, private utilService: UtilService) {
    }

    ngOnChanges() {
        this.getSearchOpportunityQuestionMap();
    }

    private getSearchOpportunityQuestion() {
        if (this.opportunityID > 0) {
            this.utilService.isLoading = true;
            this.crmService.getSearchOpportunityQuestion().subscribe(result => {
                this.utilService.isLoading = false;
                this.questionList = result.resultCollection;
                for (var i = 0; i < this.questionList.length; i++) {
                    var idx = this.questionMapList.findIndex(t => t.opportunityQuestionID == this.questionList[i].opportunityQuestionID);
                    if (idx < 0) {
                        var questionMap = this.questionList[i] as SearchOpportunityQuestionMap;
                        questionMap.opportunityQuestionMapID = 0;
                        questionMap.opportunityID = this.opportunityID;
                        questionMap.answer = "";
                        this.questionMapList.push(questionMap);
                    }
                }
                this.questionMapList = this.questionMapList.sort((left, right): number => {
                    if (left.categorySortOrder < right.categorySortOrder) return -1;
                    if (left.categorySortOrder > right.categorySortOrder) return 1;
                    if (left.questionSortOrder < right.questionSortOrder) return -1;
                    if (left.questionSortOrder > right.questionSortOrder) return 1;
                    return 0;
                });
            });
        }
    }

    private getSearchOpportunityQuestionMap() {
        if (this.opportunityID > 0) {
            this.utilService.isLoading = true;
            this.crmService.getSearchOpportunityQuestionMapByOpportunityID(this.opportunityID).subscribe(result => {
                this.utilService.isLoading = false;
                this.questionMapList = result.resultCollection;
                this.getSearchOpportunityQuestion();
            });
        }
    }

    public saveAnswer(question: SearchOpportunityQuestionMap) {
        var questionMap: OpportunityQuestionMap = {
            opportunityQuestionMapID: (question.opportunityQuestionMapID == null ? 0 : question.opportunityQuestionMapID),
            opportunityQuestionID: question.opportunityQuestionID,
            opportunityID: this.opportunityID,
            answer: question.answer,
            createdByEmployeeID: (question.createdByEmployeeID > 0 ? question.createdByEmployeeID : parseInt(localStorage.getItem('EmployeeId')!)),
            createdDate: (question.createdByEmployeeID > 0 ? question.createdDate : new Date()),
            lastModifiedByEmployeeID: parseInt(localStorage.getItem('EmployeeId')!),
            lastModifiedDate: new Date()
        };
        this.crmService.saveOpportunityQuestionMap(questionMap).subscribe(result => {
            this.questionSaved.emit();
        });
    }
}
